import * as types from '../mutations'
import Upload from '@/services/image-upload'

const state = {
  uploading: false,
  isPreviewFullScreen: false,
  isMenuCollapsed: localStorage.getItem('menu') === 'true',
  previewResult: 'active'
}

const getters = {
  uploading: (state) => state.uploading,
  isPreviewFullScreen: (state) => state.isPreviewFullScreen,
  previewResult: (state) => state.previewResult,
  isMenuCollapsed: (state) => state.isMenuCollapsed
}

const actions = {
  async uploadPicture ({ commit }, file) {
    commit(types.UPLOAD_START)
    const res = await Upload.uploadPicture(file)
    commit(types.UPLOAD_DONE)
    return res
  }
}

const mutations = {

  [types.SET_PREVIEW_RESULT] (state, result) {
    state.previewResult = result
  },

  [types.CHANGE_PREVIEW_MODE] (state, isFullScreen) {
    state.isPreviewFullScreen = isFullScreen
  },

  [types.TOGGLE_MENU] (state) {
    state.isMenuCollapsed = !state.isMenuCollapsed
    localStorage.setItem('menu', state.isMenuCollapsed)
  },

  [types.UPLOAD_START] (state) {
    state.uploading = true
  },

  [types.UPLOAD_DONE] (state) {
    state.uploading = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
